<template>
    <div class="container">
        <div class="row justify-content-center align-items-center py-5">
            <div class="col-4 text-start">
                <router-link v-if="post.next" :to="{name: 'post', params: { slug: post.next.slug }}" class="text-decoration-none text-black fw-600">
                    <span aria-hidden="true"><i class="fa-solid fa-chevron-left amarillo-renault"></i></span>
                    siguiente
                </router-link>
            </div>
            <div class="col-4 text-center">
                <button @click="$router.back()" class="text-decoration-none text-black fw-600 border-0 bg-transparent">
                    volver
                </button>
            </div>
            <div class="col-4 text-end">
                <router-link v-if="post.previous" :to="{name: 'post', params: { slug: post.previous.slug }}" class="text-decoration-none text-black fw-600">
                    anterior
                    <span aria-hidden="true"><i class="fa-solid fa-chevron-right amarillo-renault"></i></span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>


export default {
    props: {
        post: Object,
    },
};
</script>
